var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgClaim = function SvgClaim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#1F313A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.89 19.625h-2.86a3.497 3.497 0 00.704-2.11A3.52 3.52 0 0030.22 14c-1.168 0-2.029.418-2.71 1.317-.57.751-.986 1.8-1.509 3.126-.523-1.326-.94-2.375-1.509-3.126-.681-.899-1.542-1.317-2.71-1.317a3.52 3.52 0 00-3.515 3.516c0 .79.262 1.521.705 2.109h-2.862c-1.163 0-2.109.946-2.109 2.11v1.406c0 .916.588 1.698 1.406 1.988v10.762c0 1.163.946 2.109 2.11 2.109h16.968c1.163 0 2.11-.946 2.11-2.11V25.13A2.113 2.113 0 0038 23.14v-1.406c0-1.163-.946-2.109-2.11-2.109zm-8.6-.622c1.078-2.732 1.487-3.597 2.929-3.597 1.163 0 2.11.946 2.11 2.11 0 1.163-.947 2.109-2.11 2.109h-3.174l.246-.622zm-5.509-3.597c1.442 0 1.851.865 2.928 3.597l.246.622h-3.174a2.112 2.112 0 01-2.11-2.11c0-1.163.947-2.109 2.11-2.109zm1.407 21.188h-5.672a.704.704 0 01-.703-.703V25.25h6.375v11.344zm0-12.75h-7.079a.704.704 0 01-.703-.703v-1.407c0-.387.316-.703.703-.703h7.078v2.813zm4.218 12.75h-2.812V21.03h2.812v15.563zm7.782-.703a.704.704 0 01-.704.703h-5.672V25.25h6.375v10.64zm1.406-12.75a.704.704 0 01-.703.703h-7.078V21.03h7.078c.387 0 .703.316.703.703v1.407z",
    fill: "#56CCF2"
  })));
};

export default SvgClaim;